import React from 'react'

export default function SupportIcon(props) {
    const { color } = props;

    return(
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={color} d="M12.906 0C15.957 0 18 2.142 18 5.328V12.6819C18 15.8589 15.957 18 12.906 18H5.103C2.052 18 0 15.8589 0 12.6819V5.328C0 2.142 2.052 0 5.103 0H12.906ZM8.991 7.6329C8.559 7.6329 8.208 7.992 8.208 8.4249V12.4029C8.208 12.8349 8.559 13.1859 8.991 13.1859C9.432 13.1859 9.783 12.8349 9.783 12.4029V8.4249C9.783 7.992 9.432 7.6329 8.991 7.6329ZM9.009 4.7799C8.568 4.7799 8.217 5.1309 8.217 5.5719C8.217 6.003 8.568 6.3549 8.991 6.3549C9.441 6.3549 9.792 6.003 9.792 5.5719C9.792 5.1309 9.441 4.7799 9.009 4.7799Z" />
        </svg>
    )
}